var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard__card" },
    [
      _vm.loaders.dashboardData ? _c("CardLoading") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dashboard__card-content",
          class: { loadingBlur: _vm.loaders.dashboardData },
          attrs: { id: "mix-charts-overview" }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "row dashboard__card-body dashboard__card-body--bordered"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "dashboard__grid dash-hearing-aid-activity__content-container"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-lg-9 col-md-12 dash-hearing-aid-activity__content-charts"
                    },
                    [_c("OverviewMixChart")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-lg-3 dashboard__card-body-col dashboard__card-body-col--shaded dash-hearing-aid-activity__overview-filters"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "card-block" },
                        [
                          _c("Filters", {
                            attrs: { "filters-shown": "['salesRange']" }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "dashboard__card-footer" }, [
            _c(
              "div",
              { staticClass: "dashboard__card-link" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "dashboard__card-link-text",
                    attrs: { to: "/purchase-activity" }
                  },
                  [_vm._v("View All")]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dashboard__card-header" }, [
      _c("div", { staticClass: "dashboard__card-title" }, [
        _vm._v("Hearing Aid Purchase Activity")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "dashboard__card-title-icon dashboard__card-title-icon--sales"
        },
        [_c("i", { staticClass: "fa fa-chart-line" })]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }